import { render, staticRenderFns } from "./Summaries.vue?vue&type=template&id=17f0cda0&scoped=true"
import script from "./Summaries.vue?vue&type=script&lang=js"
export * from "./Summaries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f0cda0",
  null
  
)

export default component.exports